module.exports = __webpack_public_path__ + "static/media/WomanStressed.0b7a4933.png";